/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class AdsAPI extends ApiClient {
  constructor() {
    super('ads', { accountScoped: true });
  }

  summary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }

  trends(days) {
    return axios.get(`${this.url}/trends`, { params: { days } });
  }

  connections() {
    return axios.get(`${this.url}/connections`);
  }

  authorize(provider) {
    return axios.post(`${this.url}/${provider}/authorization`);
  }

  disconnect(provider) {
    return axios.delete(`${this.url}/connections/${provider}`);
  }

  assets(provider) {
    return axios.get(`${this.url}/assets`, { params: { provider } });
  }

  updateAsset(id, selected) {
    return axios.patch(`${this.url}/assets/${id}`, { asset: { selected } });
  }

  inboxAssets() {
    return axios.get(`${this.url}/inbox_assets`);
  }

  updateInboxAssets(inboxId, assetIds) {
    return axios.put(`${this.url}/inbox_assets/${inboxId}`, {
      ads_asset_ids: assetIds,
    });
  }

  campaigns(params = {}) {
    return axios.get(`${this.url}/campaigns`, { params });
  }

  campaign(id, params = {}) {
    return axios.get(`${this.url}/campaigns/${id}`, { params });
  }

  exportCampaigns(params = {}) {
    return axios.get(`${this.url}/campaigns/export`, {
      params,
      responseType: 'blob',
    });
  }

  conversations(params = {}) {
    return axios.get(`${this.url}/conversations`, { params });
  }

  conversationTrace(id) {
    return axios.get(`${this.url}/conversations/${id}/trace`);
  }

  conversationCreative(id) {
    return axios.get(`${this.url}/conversations/${id}/creative`);
  }

  goals(params = {}) {
    return axios.get(`${this.url}/goals`, { params });
  }

  organicVisits(params = {}) {
    return axios.get(`${this.url}/organic_visits`, { params });
  }

  goalEvents(id, params = {}) {
    return axios.get(`${this.url}/goals/${id}/events`, { params });
  }

  createGoal(payload) {
    return axios.post(`${this.url}/goals`, payload);
  }

  updateGoal(id, payload) {
    return axios.patch(`${this.url}/goals/${id}`, payload);
  }

  settings() {
    return axios.get(`${this.url}/settings`);
  }

  updateSettings(settings) {
    return axios.patch(`${this.url}/settings`, { settings });
  }

  diagnostics() {
    return axios.get(`${this.url}/diagnostics`);
  }

  syncRuns(params = {}) {
    return axios.get(`${this.url}/sync_runs`, { params });
  }

  sync(provider) {
    return axios.post(`${this.url}/sync_runs`, { provider });
  }

  testTracking(source, payload) {
    return axios.post(`${this.url}/tracking_tests`, { source, payload });
  }

  kanbanBoards() {
    return axios.get(this.url.replace(/\/ads$/, '/kanban/boards'));
  }
}

export default new AdsAPI();
